import React from 'react'
import { useAuthState } from 'react-firebase-hooks/auth';
import { Redirect } from 'react-router-dom'
import { DataContext } from '../../../state/DataContext/DataContext';
import { auth } from '../../../utils/firebase';

export default function RedirectIfLoggedIn() {

    const [user] = useAuthState(auth);
    const { data, actions } = React.useContext(DataContext);

    React.useEffect(() => {
        if (user) {
            actions.Auth.GetTenantIDandRoleIDbyUserID(user.uid)
        }
    }, [user])

    return (
        <div>
            {(user && data?.tenantID && data.Role) && <Redirect to={`${data.tenantID}/${data.Role === "Admin" ? "admin" : "user"}`} />}
        </div>
    )
}
